export const REDIRECT_TIMEOUT_MS = 2500
